import { Component, ElementRef, Renderer2 } from '@angular/core';

@Component({
    standalone: false,
    selector: 'cva-copyright',
    templateUrl: './copyright.component.html',
    styleUrl: './copyright.component.scss',
    
})
export class CopyrightComponent {
  constructor(private readonly el: ElementRef, private readonly renderer: Renderer2) { }
  showHide() {
    const element = this.el.nativeElement.querySelector('.secondDiv');
    const computedStyle = window.getComputedStyle(element);
    if (computedStyle.display == 'none') {
      this.renderer.setStyle(element, 'display', 'block');
    } else {
      this.renderer.setStyle(element, 'display', 'none');
    }
  }
}
